import React from 'react';
//
import Layout from 'components/layout';
import DealList from 'components/deal-list';
import PageContainer from 'components/page-container';
import labels from 'constants/labels';
import { dashboardTestId } from 'pages/dashboard/test-ids';

interface IDashboardPageProps {
  setPageTitle: (title: string) => void;
  resetSidebar: () => void;
  setSidebarHeaderVisibility: (visible: boolean) => void;
}

export default ({ setPageTitle, resetSidebar, setSidebarHeaderVisibility }: IDashboardPageProps) => {
  setPageTitle(labels.titles.site);
  resetSidebar();
  setSidebarHeaderVisibility(true);

  // reset price selections in line graph
  const localStorageKeys = Object.keys(localStorage);
  localStorageKeys.forEach(key => {
    if (key.includes('line-graph-price')) {
      localStorage.removeItem(key);
    }
  });

  return (
    <Layout data-testid={dashboardTestId}>
      <PageContainer>
        <DealList />
      </PageContainer>
    </Layout>
  );
};
